import SnackbarHandler from './SnackbarHandler'

export default SnackbarHandler